export default "__VITE_ASSET__c955867c__"